import { Component, OnInit, ViewChild } from '@angular/core';
import {NgForm} from "@angular/forms";
import {LoadingController, ModalController, ToastController} from "@ionic/angular";



@Component({
  selector: 'app-product-assign',
  templateUrl: './product-assign.page.html',
  styleUrls: ['./product-assign.page.scss'],
})
export class ProductAssignPage implements OnInit {
  @ViewChild('form', {static: false}) ngForm: NgForm;


  constructor() { }

  ngOnInit() {
  }

}
